import { render, staticRenderFns } from "./trainingInformation.vue?vue&type=template&id=2713392c&scoped=true"
import script from "./trainingInformation.vue?vue&type=script&lang=js"
export * from "./trainingInformation.vue?vue&type=script&lang=js"
import style0 from "./trainingInformation.vue?vue&type=style&index=0&id=2713392c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2713392c",
  null
  
)

export default component.exports